import logo from '$lib/assets/icons/logo.svg';

// Request permission for the browser to show notifications
export const requestPermission = () => {
  if (Notification.permission !== 'granted') {
    Notification.requestPermission();
  }
};

// Sends a browser notification with a custom title, message, and optional click action
export const sendNotification = ({
  title,
  message,
  data = null,
  onClick = () => undefined,
  onlyInBackground = false,
}) => {
  // Check if the user is currently looking at the window
  // If onlyInBackground is true, and the user is looking at the window, return
  if (onlyInBackground && document.hasFocus()) return;

  // Create a new notification
  const notification = new Notification(title, {
    body: message,
    icon: logo,
    badge: logo,
  });

  // Add an event listener for when the notification is clicked
  notification.onclick = () => {
    onClick(data);
  };
};
